// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2fK5W","head":"ProcedureTableInfo_head__1fdGZ"};